import React from 'react';
import IconYellow from '../../../../../../src/components/icon/IconYellow';
import './statisticall.scss';

const StaticTench = ({ label, application }) => {
  return (
    <div>
      <div className="statistic_all_yellow">
        <div className="static_info_yellow">
          <div className="static_label_yellow">{label}</div>
          <div className="static_app_yellow">{application}</div>
        </div>
        <div>
          <IconYellow />
        </div>
      </div>
    </div>
  );
};

export default StaticTench;
